import { render, staticRenderFns } from "./RLogin.vue?vue&type=template&id=68834220&scoped=true"
import script from "./RLogin.vue?vue&type=script&lang=js"
export * from "./RLogin.vue?vue&type=script&lang=js"
import style0 from "./RLogin.vue?vue&type=style&index=0&id=68834220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68834220",
  null
  
)

export default component.exports